export const getFilterSetting = {
  data() {
    return {
      filterLabels: [],
      filterData: [],
      searchData: {
        commission_type: []
      },
    }
  },
  methods: {
    searchByNameField(labels) {
      console.log(labels)
      this.tableData = this.sourceData.filter(
          (x) => labels.length === 0 || labels.includes(x.commission_type)
      );
    },
    $_setFilterData( array, target ) {
      let labels = [],
      filter_data = []
      for ( let i = 0; i < array.length; i++ ) {
          labels.push(array[i][target]);
      }
      labels = labels.filter( function( x, i, self ) {
          return self.indexOf(x) === i;
        });
      for (let i=0; i<labels.length; i++) {
        filter_data.push(
          { value: i, label: labels[i], selected: true }
        )
      }
      this.filterLabels = labels
      this.filterData = filter_data
    },
  }
}
